interface IImageAsset {
    width: number;
    height: number;
}

// here we have to put all our images and fill up width/height
// we will reuse this for preloading images and to scale them up correctly

export const DEFAULT_MULTIPLIER = 6; // depending on screen size?

export const SPRITESHEET_FILE = 'sprite.png';

export const IMAGE_ASSETS: { [key: string]: IImageAsset } = {
    'logo-animated.gif': { width: 101, height: 84 },
    'chest-animated.gif': { width: 55, height: 51 },
    'chest-reward-animated.gif': { width: 55, height: 51 },

    'story-1.gif': { width: 68, height: 68 },
    'story-2.gif': { width: 56, height: 41 },
    'story-3.gif': { width: 68, height: 68 },
    'story-4.gif': { width: 109, height: 71 },

    'potion.gif': { width: 11, height: 15 },

    'forest-background.gif': { width: 480, height: 160 },
    'dungeon-background.gif': { width: 480, height: 160 },

    'sound-on.png': { width: 16, height: 16 },
    'sound-off.png': { width: 16, height: 16 },
}
